"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagSwIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagSwIcon = (0, _mobxReact.observer)(_class = (_FlagSwIcon = /*#__PURE__*/function (_React$Component) {
  function FlagSwIcon() {
    _classCallCheck(this, FlagSwIcon);
    return _callSuper(this, FlagSwIcon, arguments);
  }
  _inherits(FlagSwIcon, _React$Component);
  return _createClass(FlagSwIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#000",
        d: "M0 .3h100v29.5H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FF5252",
        d: "M0 35.3h100v29.5H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#13AB5E",
        d: "M0 70.5h100V100H0z"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(31 17)"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M34 11c2.9-5.1 4.6-9.7 3.7-10.2-.9-.5-3.9 3.2-6.9 8.4-2.4 4.1-3.9 7.9-3.9 9.4L.6 64.7l1 .6 26.3-46.1c1.3-.9 3.7-4.1 6.1-8.2z",
        fill: "#FDFDFD"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M4 11C1.1 5.9-.6 1.3.3.8 1.2.3 4.2 4 7.2 9.2c2.4 4.1 3.9 7.9 3.9 9.4l26.3 46.1-1 .6-26.3-46.2c-1.3-.8-3.7-4-6.1-8.1z",
        fill: "#FDFDFD"
      }), /*#__PURE__*/_react["default"].createElement("ellipse", {
        fill: "#FF5252",
        cx: "18.6",
        cy: "32.8",
        rx: "13.1",
        ry: "30.6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.5 48.7c1.2-4.6 1.8-9.9 1.8-15.5 0-6-.7-11.6-2-16.3-1.2 4.6-1.8 9.9-1.8 15.5 0 6 .7 11.6 2 16.3zM29.9 48.7c-1.2-4.6-1.8-9.9-1.8-15.5 0-6 .7-11.6 2-16.3 1.2 4.6 1.8 9.9 1.8 15.5.1 6-.7 11.6-2 16.3z",
        fill: "#020003"
      }), /*#__PURE__*/_react["default"].createElement("ellipse", {
        fill: "#FDFDFD",
        cx: "18.4",
        cy: "33",
        rx: "2.7",
        ry: "3.8"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M17.8 2.6c-2.1 2.1-3.5 7.3-3.5 13.4 0 5.9 1.4 10.9 3.3 13.2h.2V2.6zM17.8 63c-2.1-2.1-3.5-7.3-3.5-13.4 0-5.9 1.4-10.9 3.3-13.2h.2V63zM18.7 2.6c2.1 2.1 3.5 7.3 3.5 13.4 0 5.9-1.4 10.9-3.3 13.2h-.2V2.6zM18.7 63c2.1-2.1 3.5-7.3 3.5-13.4 0-5.9-1.4-10.9-3.3-13.2h-.2V63z",
        fill: "#FDFDFD"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagSwIcon.defaultProps = {
  width: '20px'
}, _FlagSwIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagSwIcon);